import { render, staticRenderFns } from "./select-system.vue?vue&type=template&id=54420b10&scoped=true&"
import script from "./select-system.vue?vue&type=script&lang=js&"
export * from "./select-system.vue?vue&type=script&lang=js&"
import style0 from "./select-system.vue?vue&type=style&index=0&id=54420b10&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54420b10",
  null
  
)

export default component.exports